"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "AdminTool_"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.19,1.74V7.19H1.74V1.74H7.19M8.93,0H0V8.93H8.93V0Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.26,1.74V7.19H16.81V1.74h5.45M24,0H15.07V8.93H24V0Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.23,16.81v5.45H1.78V16.81H7.23m1.7-1.74H0V24H8.93V15.07Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.96",
    width: "2.09",
    height: "8.93",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7.62",
    y: "12.02",
    width: "16.38",
    height: "2.01",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    y: "10",
    width: "4.23",
    height: "2.01",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.48",
    y: "17.02",
    width: "6.55",
    height: "2.01",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "21.91 17.02 21.91 21.91 15.03 21.91 15.03 24 24 24 24 23.98 24 21.91 24 17.02 21.91 17.02",
    fill: "#024965"
  }), ' ');
};

exports["default"] = _default;